import { useL10n } from "@ews/react-localization-context";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import { TooltipIcon } from "../../../ToolTip/useTooltip";

const SumbmissionDocuments: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();
    return <>
        <SettingsCheckbox
            text={t("TRVB_SERVICE_GROUP_DIRECTORY_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_SERVICE_GROUP_DIRECTORY_LABEL")} />}
            checked={specification.submissionDocuments?.controlGroupDirectoryFireAlarmGroups || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.controlGroupDirectoryFireAlarmGroups === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            controlGroupDirectoryFireAlarmGroups: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_LIST_OF_ACTUATIONS_1]")}
            tooltip={<TooltipIcon text={t("[REACT_LIST_OF_ACTUATIONS_1]")} />}
            checked={specification.submissionDocuments?.controlGroupDirectory1 || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.controlGroupDirectory1 === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            controlGroupDirectory1: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_LIST_OF_ACTUATIONS_2]")}
            tooltip={<TooltipIcon text={t("[REACT_LIST_OF_ACTUATIONS_2]")} />}
            checked={specification.submissionDocuments?.controlGroupDirectory2 || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.controlGroupDirectory2 === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            controlGroupDirectory2: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("[REACT_LIST_OF_ACTUATIONS_3]")}
            tooltip={<TooltipIcon text={t("[REACT_LIST_OF_ACTUATIONS_3]")} />}
            checked={specification.submissionDocuments?.controlGroupDirectory3 || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.controlGroupDirectory3 === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            controlGroupDirectory3: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_INPUTS_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_INPUTS_LABEL")} />}
            checked={specification.submissionDocuments?.inputs || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.inputs === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            inputs: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_SUBMISSION_NETWORKING_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_SUBMISSION_NETWORKING_LABEL")} />}
            checked={specification.submissionDocuments?.networkingSubmission || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.networkingSubmission === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            networkingSubmission: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_FIRE_SAFETY_PLANS_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_FIRE_SAFETY_PLANS_LABEL")} />}
            checked={specification.submissionDocuments?.fireProtectionPlans || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.fireProtectionPlans === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            fireProtectionPlans: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_FIRE_CONFIRM_COMPANY_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_FIRE_CONFIRM_COMPANY_LABEL")} />}
            checked={specification.submissionDocuments?.certifiedCompanyExecutionConfirmation || false}
            onChange={(checked) =>
            {
                if (specification.submissionDocuments?.certifiedCompanyExecutionConfirmation === checked) return;
                if (systemId && specification.submissionDocuments) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        submissionDocuments: {
                            ...specification.submissionDocuments,
                            certifiedCompanyExecutionConfirmation: checked
                        },
                    });
                }
            }} />
    </>;
};

export default SumbmissionDocuments;
